export default "__VITE_ASSET__YqORTHi8__"